<template>
  <div class="wrap">
    <p class="title">温馨提示</p>
    <p class="desc">如查看相关订单信息，需自行前往微信中查看</p>
    <img class="img" src="../../assets/images/payResult.png" alt />
  </div>
</template>

<script>
  export default{
    data(){
      return{
      }
    },
    mounted(){
    }
  }
</script>

<style scoped>
  .wrap{
    width: 100%;
    padding-top: 1rem ;
  }
  .title{
    font-size: .36rem;
    line-height: .5rem;
    color: #101010;
    font-weight: 500;
    margin: 0 auto .24rem;
    text-align: center;
  }
  .desc{
    font-size: .3rem;
    line-height: .42rem;
    color: #101010;
    font-weight: 500;
    margin: 0 auto 1.28rem;
    text-align: center;
  }
  .img{
    width: 3.47rem;
    display: block;
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/index/payResult.vue